import {
    React,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Divider,
    Typography,
    Box
} from '../../utils/globalImports';

import {
    EditIcon,
    DeleteIcon
} from '../../utils/globalImports';


export interface EntryItem {
    id: number;
    name: string;
    description: string;
}

interface EntryListProps {
    entries: EntryItem[];
    onEdit: (entry: EntryItem) => void;
    onDelete: (id: number) => void;
    heading?: string;
}

const CustomList: React.FC<EntryListProps> = ({ entries, onEdit, onDelete, heading }) => {
    return (
        <Box
            sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                maxHeight: '60vh', // Dynamic height: grows until 60% of viewport
                overflowY: 'auto',
                backgroundColor: '#f9f9f9',
                position: 'relative',
            }}
        >
            {/* Sticky Header */}
            <Box
                sx={{
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#fff',
                    zIndex: 1,
                    px: 2,
                    py: 1,
                    borderBottom: '1px solid #ccc',
                }}
            >
                <Typography variant="h6" sx={{ color: '#1e66ab', fontSize: 16, fontWeight: 550 }}>
                    {heading}
                </Typography>
            </Box>

            {/* Scrollable List */}
            <List disablePadding>
                {entries.map((entry, index) => (
                    <React.Fragment key={entry.id}>
                        {index > 0 && <Divider />}
                        <ListItem
                            secondaryAction={
                                <>
                                    <IconButton edge="end" onClick={() => onEdit(entry)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton edge="end" onClick={() => onDelete(entry.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </>
                            }
                        >
                            <ListItemText
                                primary={entry.name}
                                primaryTypographyProps={{ sx: { color: '#1e66ab', fontSize: 14 } }}
                            />
                        </ListItem>
                    </React.Fragment>
                ))}

                {entries.length === 0 && (
                    <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', mt: 2 }}>
                        No entries available
                    </Typography>
                )}
            </List>
        </Box>
    );
};

export default CustomList;
